import createIcon from '../../createIcon';

/**
 * @component @name TurnLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC44MyAxMEwxMC40MiAxMS41OUw5IDEzTDUgOUw5IDVMMTAuNDEgNi40MUw4LjgzIDhIMTdDMTguMSA4IDE5IDguOSAxOSAxMFYxOUgxN1YxMEg4LjgzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TurnLeft = createIcon('TurnLeft', [
  [
    'path',
    {
      d: 'M8.83 10L10.42 11.59L9 13L5 9L9 5L10.41 6.41L8.83 8H17C18.1 8 19 8.9 19 10V19H17V10H8.83Z',
      key: 'd6f3gy',
    },
  ],
]);

export default TurnLeft;
